import { IThangDiem } from "../../models/response/so-diem/IThangDiem"
import { generateActionTypeIds } from "./generateActionTypeIds"
import IGenericActionType from "./IGenericActionType"


export const eThangDiemActionTypeDefine = {
    CHANGE_TRUONG_ID: 0,
    LOAD_START: 0,
    LOAD_SUCCESS: {} as IThangDiem[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | IThangDiem,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IThangDiem,
    SAVE_SUCCESS: {} as IThangDiem,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eThangDiemActionTypeIds = generateActionTypeIds(eThangDiemActionTypeDefine, "THANG_DIEM")

export type IThangDiemActions = IGenericActionType<typeof eThangDiemActionTypeDefine, "THANG_DIEM">